"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CategoryCodeLGBT = function CategoryCodeLGBT(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 16 16"
  }, props), _react.default.createElement("g", null, _react.default.createElement("title", null, "CategoryCodeLGBT"), _react.default.createElement("path", {
    d: "M13.25,2.092H11.232a.414.414,0,0,0-.413.413v.382a.413.413,0,0,0,.413.413h.4L9.935,5a3.364,3.364,0,0,0-3.853-.041L5.8,4.668l.526-.527a.4.4,0,0,0,.121-.292.411.411,0,0,0-.121-.293l-.269-.269a.415.415,0,0,0-.585,0l-.527.527L4.428,3.3h.34a.413.413,0,0,0,.413-.413V2.505a.414.414,0,0,0-.413-.413H2.75a.414.414,0,0,0-.413.413V4.523a.414.414,0,0,0,.413.414h.382a.415.415,0,0,0,.413-.414v-.4l.542.542L3.56,5.2a.413.413,0,0,0,0,.584l.27.27a.411.411,0,0,0,.292.121h0a.411.411,0,0,0,.293-.121l.526-.527.282.282a3.332,3.332,0,0,0-.61,1.931,3.379,3.379,0,0,0,2.763,3.311V11.5H6.631a.415.415,0,0,0-.414.413v.382a.414.414,0,0,0,.414.413h.745v.79a.414.414,0,0,0,.413.413H8.17a.415.415,0,0,0,.414-.413v-.79h.745a.413.413,0,0,0,.413-.413V11.91a.414.414,0,0,0-.413-.413H8.584v-.451a3.379,3.379,0,0,0,2.762-3.311,3.338,3.338,0,0,0-.569-1.873l1.678-1.679v.34a.415.415,0,0,0,.413.414h.382a.414.414,0,0,0,.413-.414V2.505A.414.414,0,0,0,13.25,2.092ZM10.138,7.735A2.159,2.159,0,1,1,7.98,5.577,2.16,2.16,0,0,1,10.138,7.735Z"
  })));
};

var _default = CategoryCodeLGBT;
exports.default = _default;